import { isEmpty } from "lodash"
import React, { useState } from "react"
import { Col, Form, InputGroup, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Select, { SingleValue } from "react-select"
import Flag from "react-world-flags"
import CheckIcon from "../../../assets/check.svg"
import TrashIcon from "../../../assets/trash.svg"
import { SERVICE_TYPE } from "../../../constants/constants"

const UpdateOrCreateCustomerAddedValueService = ({
    variationData,
    setVariationData,
    selectedWarehouse,
    valueAddedServices,
    customer,
    newRate,
    setNewRate,
    rateType,
    setRateType,
    handleSubmit,
    setSelectedWarehouse,
    setUpdateModalWarehouse,
    setShowConfirmModal,
    customerValueAddedServices
}: {
    variationData: Record<string, any>
    setVariationData: Function
    selectedWarehouse: Record<string, any>
    valueAddedServices: Record<string, any>[]
    customer: Record<string, any>
    newRate: number
    setNewRate: Function
    rateType: string
    setRateType: Function
    handleSubmit: Function
    setSelectedWarehouse: Function
    setUpdateModalWarehouse: Function
    setShowConfirmModal: Function
    customerValueAddedServices: Record<string, any>[]
}) => {
    const { t } = useTranslation()
    const [selectedService, setSelectedService] = useState(variationData?.service)

    return (
        <tr className="rounded justify-content-around">
            <td className="col-3">
                <Select
                    name="valueAddedService"
                    options={valueAddedServices
                        .filter(
                            (vas) =>
                                !customerValueAddedServices
                                    ?.map((cvas) => cvas?.value_added_service)
                                    .includes(vas?.id)
                        )
                        ?.map((vas: Record<string, any>) => {
                            return { value: vas?.id, label: vas?.service }
                        })}
                    defaultValue={
                        variationData?.service && {
                            value: valueAddedServices?.find((vas) => vas?.service === variationData?.service)
                                ?.id,
                            label: variationData?.service
                        }
                    }
                    className="basic-select text-capitalize"
                    classNamePrefix="select"
                    isDisabled={!!variationData?.id}
                    onChange={(service: SingleValue<Record<string, any>>) => {
                        setSelectedService(service?.label)
                        setVariationData({ ...variationData, value_added_service: service?.value })
                    }}
                />
            </td>
            <td className="col-2">
                <Flag
                    className={"w-25 d-inline"}
                    code={selectedWarehouse?.country || variationData?.Warehouse?.country}
                />
                &nbsp;&nbsp;{selectedWarehouse?.country || variationData?.Warehouse?.country}
            </td>
            <td className={"col-2 d-flex"}>
                <span>
                    {valueAddedServices?.find((vas) => vas?.service === selectedService)?.service_value || 0}
                </span>
                <span>
                    {valueAddedServices?.find((vas) => vas?.service === selectedService)?.service_type ===
                    "flat"
                        ? "$"
                        : "%"}
                </span>
            </td>
            <td className={"col-3"}>
                <Row>
                    <Col
                        lg={
                            variationData?.is_service_charge ||
                            valueAddedServices?.find((vas) => vas?.service === selectedService)
                                ?.is_service_charge
                                ? 7
                                : 12
                        }>
                        <Row>
                            <Col lg={10} className="mb-2">
                                <Form.Group>
                                    {/* <InputGroup> */}
                                    <Form.Control
                                        id="userServiceValue"
                                        type="number"
                                        autoComplete="off"
                                        name={"default_value"}
                                        value={variationData?.service_value || 0}
                                        onChange={(e: any) => {
                                            setVariationData({
                                                ...variationData,
                                                service_value: parseFloat(e.target.value),
                                                service_type: variationData?.service_type
                                                    ? variationData.service_type
                                                    : SERVICE_TYPE["1"]
                                            })
                                        }}
                                        placeholder="Default Value"
                                        isInvalid={
                                            (variationData?.service_value <= 0 &&
                                                variationData?.service_type === SERVICE_TYPE["1"]) ||
                                            Number.isNaN(variationData?.service_value)
                                                ? true
                                                : false
                                        }
                                    />
                                    {variationData?.service_value &&
                                    variationData?.service_value <= 0 &&
                                    variationData?.service_type === SERVICE_TYPE["1"] ? (
                                        <Form.Control.Feedback type="invalid">
                                            {t(`VAS discount value cannot be 0 or less.`)}
                                        </Form.Control.Feedback>
                                    ) : null}

                                    {/* <InputGroup.Text
                                className="tr-pointer"
                                onClick={() => setVariationData({
                                    ...variationData,
                                    service_type: variationData.service_type === SERVICE_TYPE["0"] ?
                                        SERVICE_TYPE["1"]
                                        :
                                        SERVICE_TYPE["0"]
                                })}
                            >
                                {variationData?.service_type === SERVICE_TYPE["0"] ? "$" : "%"}
                            </InputGroup.Text>
                        </InputGroup> */}
                                </Form.Group>
                            </Col>
                            <Col lg={6}>
                                <Form.Check
                                    type="radio"
                                    name="service_type"
                                    label={t("$")}
                                    onChange={(e: any) => {
                                        setVariationData({ ...variationData, service_type: SERVICE_TYPE["0"] })
                                    }}
                                    required={true}
                                    checked={variationData?.service_type === SERVICE_TYPE["0"]}
                                />
                            </Col>
                            <Col lg={6}>
                                <Form.Check
                                    type="radio"
                                    name="service_type"
                                    label={t("%")}
                                    onChange={(e: any) => {
                                        setVariationData({ ...variationData, service_type: SERVICE_TYPE["1"] })
                                    }}
                                    required={true}
                                    checked={variationData?.service_type === SERVICE_TYPE["1"]}
                                />
                            </Col>
                        </Row>
                    </Col>
                    {variationData?.is_service_charge ||
                    valueAddedServices?.find((vas) => vas?.service === selectedService)?.is_service_charge ? (
                        <Col lg={5}>
                            <InputGroup>
                                <Form.Control
                                    id="userServiceMinValue"
                                    type="number"
                                    autoComplete="off"
                                    name={"min_value"}
                                    className="w-75"
                                    value={variationData?.min_value || 0}
                                    onChange={(e: any) => {
                                        setVariationData({
                                            ...variationData,
                                            min_value: parseFloat(e.target.value)
                                        })
                                    }}
                                    placeholder="Default Value"
                                    isInvalid={
                                        variationData?.min_value < 0 || Number.isNaN(variationData?.min_value)
                                            ? true
                                            : false
                                    }
                                />
                                <Form.Control type="text" value={"$"} className="px-1" readOnly />
                                <small className="text-muted px-1">{t("Min value")}</small>
                            </InputGroup>

                            {variationData?.min_value && variationData?.min_value < 0 ? (
                                <Form.Control.Feedback type="invalid">
                                    {t(`VAS min value cannot be 0 or less.`)}
                                </Form.Control.Feedback>
                            ) : null}
                        </Col>
                    ) : null}
                    {/* <Col lg={12}>
                <input
                    type="number"
                    className=" mb-2 form-control"
                    min="0"
                    value={variationData?.service_value}
                    onChange={(e) =>
                        setVariationData({ ...variationData, service_value: parseFloat(e.target.value) })
                    }
                />
                </Col>
                <Col lg={6}>
                    <Form.Check
                        type="radio"
                        name="service_type"
                        label={t("Flat")}
                        onChange={(e: any) => {
                            setVariationData({ ...variationData, service_type: "flat" })
                        }}
                        required={true}
                        checked={
                            variationData?.service_type === "flat"
                        }
                    />
                </Col>
                <Col lg={6}>
                    <Form.Check
                        type="radio"
                        name="service_type"
                        label={t("Percentage")}
                        onChange={(e: any) => {
                            setVariationData({ ...variationData, service_type: "percent" })
                        }}
                        required={true}
                        checked={
                            variationData?.service_type === "percent"
                        }
                    />
                </Col> */}
                </Row>
            </td>
            <td className="col-1 d-flex justify-content-between align-items-start">
                <img
                    className="tr-pointer w-50 py-1"
                    src={CheckIcon}
                    onClick={() => {
                        if (!isEmpty(variationData)) {
                            handleSubmit(variationData, "services")
                            setSelectedWarehouse({})
                            setUpdateModalWarehouse(0)
                            setVariationData({})
                        }
                    }}
                />
                <img
                    className="tr-pointer w-50 py-1 mx-1"
                    src={TrashIcon}
                    onClick={() => {
                        setShowConfirmModal("deleteVasDiscount")
                    }}
                />
            </td>
        </tr>
    )
}

export default UpdateOrCreateCustomerAddedValueService
